<template>
  <FieldGrid
    :fields="processedGrid"
    :dv="dv"
    :cell-slots="$slots"
    :validation-errors="validationErrors"
  >
    <template v-if="isSuperUser" #is_template>
      <FieldComponent
        :field-meta="dv.modelAttributes['is_template']"
        :data="dv.editedRecord['is_template']"
        :is-edit-mode="dv.isEditing"
        @edit="(value) => dv.edit({ name: 'is_template' }, value)"
      />
    </template>
    <template v-if="fieldPage !== 'new'" #run_dir>
      <FieldComponent
        :field-meta="dv.modelAttributes['run_dir']"
        :data="dv.editedRecord['run_dir']"
        :is-edit-mode="dv.isEditing"
        @edit="(value) => dv.edit({ name: 'run_dir' }, value)"
      />
    </template>
    <template v-if="fieldPage !== 'new'" #studies>
      <FieldComponent
        :field-meta="dv.modelAttributes['studies']"
        :data="dv.editedRecord['studies']"
        :is-edit-mode="dv.isEditing"
        @edit="(value) => dv.edit({ name: 'studies' }, value)"
      />
    </template>
    <template v-if="fieldPage !== 'new'" #id>
      <FieldComponent
        :field-meta="dv.modelAttributes['id']"
        :data="dv.editedRecord['id']"
        :is-edit-mode="dv.isEditing"
        @edit="(value) => dv.edit({ name: 'id' }, value)"
      />
    </template>
  </FieldGrid>
</template>

<script>
import { computed, inject } from 'vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'
import { expandCustomProperties } from '../../shared/fieldConstants.js'

export default {
  name: 'AssayDescriptionGrid',
  components: {
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
    fields: { type: Array, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const fieldPage = inject('fieldPage', 'detail')
    const isSuperUser = inject('isSuperUser', false)

    const processedGrid = computed(() =>
      expandCustomProperties(props.fields, props.dv.customProperties),
    )

    return { processedGrid, fieldPage, isSuperUser }
  },
}
</script>
